import React, { useState } from 'react'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useSelector } from 'react-redux'
import { Text } from '@src/components/base/Text'
import { BottomSheet } from '@src/components/BottomSheet'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useDispatchAsync, useGoBack } from '@src/utils'
import { useSnack } from '@src/utils/navigatorContext'
import { userSelector } from '@src/selectors/app'
import { Option, OptionType } from '@src/screens/Questionnaire/components/inputs/Shared/Option'

export const ReferredToPurchasedByNutritionistModal = () => {
  const styles = useStyleSheet(themedStyles)
  const showSnack = useSnack()
  const user = useSelector(userSelector)
  const dispatchAsync = useDispatchAsync()
  const goBack = useGoBack()

  const [option, setOption] = useState<boolean | undefined>(undefined)
  const [loading, setLoading] = useState(false)

  const nutritionist = user?.lastOccurredCoachingAppointment?.providers[0]?.coach

  const handleOptionPress = async (option: boolean) => {
    try {
      setLoading(true)

      await dispatchAsync({
        type: 'users/answerReferredToPurchase',
        payload: {
          referred: option,
        },
      })

      goBack()
    } catch {
      showSnack('Error saving response. Please try again.', null, 'error')
    } finally {
      setLoading(false)
    }
  }

  const title = nutritionist
    ? `Were you referred by ${nutritionist.fullName} to purchase?`
    : 'Were you referred by your nutritionist to purchase?'

  return (
    <BottomSheet>
      <SafeAreaView edges={['bottom']} style={styles.container}>
        <Text type="title-2" style={styles.title}>
          {title}
        </Text>
        {loading ? (
          <Text type="title-3" style={styles.title}>
            Saving response...
          </Text>
        ) : (
          <>
            <Option
              label="Yes"
              type={OptionType.Radio}
              onPress={() => {
                setOption(true)
                handleOptionPress(true)
              }}
              style={styles.option}
              selected={option === true}
            />
            <Option
              label="No"
              type={OptionType.Radio}
              onPress={() => {
                setOption(false)
                handleOptionPress(false)
              }}
              style={styles.option}
              selected={option === false}
            />
          </>
        )}
      </SafeAreaView>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  container: {
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    fontSize: 18,
    maxWidth: 260,
    marginTop: 16,
    marginBottom: 24,
    color: 'theme.text.primary',
  },
  option: {
    width: '100%',
  },
})
